var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMandiriLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 33,
    viewBox: "0 0 112 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "-.817%",
    x2: "106.004%",
    y1: "49.844%",
    y2: "60.159%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FDB913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "22.472%",
    stopColor: "#FFCB05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "39.326%",
    stopColor: "#FAA61A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "52.809%",
    stopColor: "#FFCB05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64.607%",
    stopColor: "#FAA61A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.404%",
    stopColor: "#FFCB05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFCB05"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#003D79",
    d: "M.341 22.342c0-1.572-.028-2.892-.114-4.07h3.019l.143 2.023h.084c.682-1.067 1.936-2.333 4.271-2.333 1.823 0 3.246 1.013 3.843 2.527h.059c.483-.758 1.051-1.319 1.706-1.71.769-.534 1.653-.817 2.79-.817 2.307 0 4.64 1.544 4.64 5.926v8.054h-3.415V24.39c0-2.272-.797-3.62-2.477-3.62-1.196 0-2.08.842-2.449 1.825-.085.334-.17.757-.17 1.148v8.198H8.854v-7.918c0-1.905-.768-3.254-2.392-3.254-1.308 0-2.19 1.01-2.506 1.965-.142.336-.199.73-.199 1.121v8.086H.341v-9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D79",
    fillRule: "nonzero",
    d: "M34.318 28.5c0 1.234.056 2.44.196 3.283h-3.13l-.225-1.515h-.085c-.846 1.068-2.284 1.823-4.057 1.823-2.765 0-4.315-1.99-4.315-4.07 0-3.454 3.07-5.191 8.148-5.164v-.224c0-.899-.368-2.386-2.792-2.386-1.354 0-2.763.421-3.694 1.01l-.676-2.246c1.015-.618 2.791-1.208 4.96-1.208 4.4 0 5.67 2.782 5.67 5.755V28.5zm-3.384-3.395c-2.454-.058-4.793.475-4.793 2.552 0 1.348.876 1.966 1.974 1.966 1.38 0 2.396-.901 2.706-1.883.084-.253.113-.532.113-.756v-1.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D79",
    d: "M36.611 22.342c0-1.572-.03-2.892-.111-4.07h3.07l.17 2.052h.088c.596-1.068 2.105-2.362 4.41-2.362 2.42 0 4.923 1.544 4.923 5.869v8.11h-3.5v-7.716c0-1.967-.741-3.455-2.647-3.455-1.393 0-2.362.982-2.731 2.022-.113.308-.143.729-.143 1.12v8.03h-3.529v-9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D79",
    fillRule: "nonzero",
    d: "M64.928 12.86v15.653c0 1.433.06 2.984.118 3.93h-3.224l-.147-2.208h-.06c-.85 1.55-2.58 2.523-4.661 2.523-3.403 0-6.099-2.84-6.099-7.14-.03-4.678 2.96-7.462 6.391-7.462 1.964 0 3.372.803 4.017 1.84h.06V12.86h3.605zm-3.605 11.435c0-.285-.03-.63-.09-.918-.321-1.374-1.463-2.494-3.106-2.494-2.317 0-3.609 2.008-3.609 4.618 0 2.551 1.292 4.417 3.58 4.417 1.463 0 2.755-.975 3.106-2.497.09-.314.119-.66.119-1.032v-2.094z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D79",
    d: "M66.893 18.5h4.03v13.694h-4.03zM73.678 22.528c0-1.928-.028-3.301-.11-4.585h3.001l.11 2.713h.114c.673-2.012 2.27-2.713 3.732-2.713.335 0 .531-.058.81 0v3.154a4.558 4.558 0 0 0-1.007-.116c-1.657 0-2.78 1.108-3.087 2.711a6.652 6.652 0 0 0-.111 1.113v7.355h-3.452v-9.632zM83.012 18.5h4.03v13.694h-4.03V18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M38.946 13.134a3010.628 3010.628 0 0 0-9.107-5.237c-2.616-1.082-4.62.236-5.27 1.202a.802.802 0 0 0-.076.116l-.086.147-.442.723c-.188.3-.398.607-.639.923-.215.276-.453.55-.713.814-1.68 1.702-4.367 2.898-8.845.762-2.709-1.55-9.006-5.163-9.006-5.163l-.001-.002L.15 4.777l2.385-2.938C3.539.88 5.426-.693 8.344.634c0 0 8.055 4.678 8.087 4.692 6.886 3.79 10.285.168 11.786-2.246.052-.075.096-.157.142-.23l.003-.004c.018-.029.031-.056.046-.084l.171-.28C29.31 1.37 30.465.653 31.84.685c.76.015 1.275.264 2.024.682L41.658 5.9c.005.002.009.005.017.007 6.971 3.837 10.427-.022 11.903-2.436.114-.21.246-.408.378-.595.73-.993 1.74-1.645 3.019-1.613.844.017 1.794.526 1.933.62l9.345 5.408s-.956 1.446-2.922 3.702c-1.758 2.011-3.627 1.1-5.113.36-.624-.309-5.135-2.874-5.135-2.874-2.471-1.023-4.396.093-5.152 1.032-.078.1-.145.192-.196.282l-.174.306c-.271.459-.594.975-.992 1.486-.213.277-.45.554-.712.815-1.039 1.053-2.46 1.911-4.449 1.912-1.249 0-2.72-.338-4.462-1.178",
    transform: "matrix(1 0 0 -1 43.52 14.472)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMandiriLogo);
export default __webpack_public_path__ + "static/media/mandiri-logo.8fc9b7cd1cec3f247b03f0ba20f87740.svg";
export { ForwardRef as ReactComponent };